import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
    <path fill={props.fill || '#1D252D'} d="M141.77-100 100-141.77 378.23-420H180v-60h300v300h-60v-198.23zM480-480v-300h60v198.23L818.23-860 860-818.23 581.77-540H780v60z"></path>
  </svg>;
export default React.memo(SvgIcon);